import React, { useRef, useState } from "react";
import { Toast } from "./Toast";
import ToastContext from "./ToastContext";
import styles from  './Toast.module.css';

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const toastsCount = useRef(0);

  const showToast = (message, type = 'success', duration = 5000) => {
    const id = toastsCount.current++;
    setToasts((prevToasts) => [...prevToasts, { id, message, type, duration }]);

    if (duration) {
      setTimeout(() => {
        hideToast(id);
      }, duration)
    }

    return id;
  };

  const hideToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const showSuccessToast = (message, duration) => showToast(message, 'success', duration);

  const showErrorToast = (message, duration) => showToast(message, 'error', duration);

  const showWarningToast = (message, duration) => showToast(message, 'warning', duration);

  const showInfoToast = (message, duration) => showToast(message, 'info', duration);

  return (
    <ToastContext.Provider
      value={{
        showToast,
        hideToast,
        showSuccessToast,
        showErrorToast,
        showWarningToast,
        showInfoToast,
      }}
    >
      {children}
      <div className={styles.toastContainer}>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={() => hideToast(toast.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
};